
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 0C7.2787 0 7.53355 0.153649 7.65856 0.397045L9.44509 3.87546L13.3544 4.3521C13.6322 4.38597 13.8663 4.57075 13.9587 4.82898C14.0511 5.08722 13.9857 5.3743 13.79 5.56991L11.0076 8.35072L11.7737 12.1405C11.8277 12.4074 11.7231 12.6812 11.5033 12.8483C11.2836 13.0153 10.9862 13.0471 10.7347 12.9304L7 11.1969L3.26529 12.9304C3.01379 13.0471 2.71643 13.0153 2.49668 12.8483C2.27692 12.6812 2.17231 12.4074 2.22627 12.1405L2.99244 8.35072L0.209998 5.56991C0.0142811 5.3743 -0.0510888 5.08722 0.0412865 4.82898C0.133662 4.57075 0.367823 4.38597 0.645625 4.3521L4.55491 3.87546L6.34144 0.397045C6.46645 0.153649 6.7213 0 7 0Z","fill":"#E86A5E"}})])
          )
        }
      }
    